import { render, staticRenderFns } from "./NoSesion.vue?vue&type=template&id=0fa01a70&scoped=true"
import script from "./NoSesion.vue?vue&type=script&lang=js"
export * from "./NoSesion.vue?vue&type=script&lang=js"
import style0 from "./NoSesion.vue?vue&type=style&index=0&id=0fa01a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa01a70",
  null
  
)

export default component.exports